import CreateLastMinutePromotion from './CreateLastMinutePromotion.container';

export default CreateLastMinutePromotion;
